import { Outlet, useLocation } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import ThemeSwitcher from "../Theme/ThemeSwitcher";
import Footer from "../Footer/Footer";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import Loader from "../../common/Loader/Loader";

export const RootLayout = () => {
  const broker = import.meta.env.VITE_BROKER;
  const [data, setData] = useState();
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    async function fetchData() {
      const data = await import(
        `../../data/${broker.toLowerCase()}/metadata.json`
      );

      setData(data.default);
    }

    fetchData();
  }, [broker]);

  if (!data) {
    return <Loader />;
  }

  let metaKey = pathname;
  if (pathname.startsWith("/rca")) {
    metaKey = "/rca";
  }

  const meta = data[metaKey] || data["default"];

  return (
    <>
      <Helmet key={pathname}>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta property="og:site_name" content={data.siteName} />
        <meta property="og:title" content={meta.title} />
        <meta property="og:description" content={meta.ogDescription} />
        <meta property="og:type" content="website" />
        <link rel="canonical" href={metaKey} />
      </Helmet>
      <Navbar />
      <ThemeSwitcher />
      <div className="bg-white dark:bg-dark-300">
        <Outlet />
      </div>
      <Footer />
    </>
  );
};
